import { NavLink, useNavigate } from "react-router-dom"
import "../styles/Home.css"
import {  useEffect, useState } from "react";
import "../styles/Gallery.css"
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { HiPhoto } from "react-icons/hi2";
import { FaArrowRight } from "react-icons/fa";
import { Modal } from '@mantine/core';

import video1 from "../assets/images/gallery/video1.mp4"
import video2 from "../assets/images/gallery/video2.mp4"
import img2 from "../assets/images/gallery/2.jpg" 
import img5 from "../assets/images/gallery/5.jpg" 
import img6 from "../assets/images/gallery/6.jpg" 
import img7 from "../assets/images/gallery/7.jpg" 
import img9 from "../assets/images/gallery/9.jpg" 
import img10 from "../assets/images/gallery/10.jpg"
import img11 from "../assets/images/gallery/11.jpg"
import img13 from "../assets/images/gallery/13.jpg"


const Home = () => {
    
    const [image, setViewImage] =useState(false)
    const [imageUrl, setImageUrl] =useState()
    const setImage = (url) => {
        setViewImage(true)
        setImageUrl(url)
    }
    const navigate = useNavigate();  // Use useNavigate hook

    const navigateToTribute = () => {
        navigate('/tributes/action');  // Navigate to the tribute page
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return <>
        <div className="heroSection">
            <div className="leftHero">
                <h2>Mrs Ezinne Cecilia Akukananwa Igwegbu, Nee Nzekwe (Nneoma) </h2>
                <p>With gratitude to God for a life well spent, we the Igwegbu family of Imama Akama Oghe in Ezeagu Local Government Area of Enugu State announce the transition to glory of our beloved mother.</p>
                <button onClick={() => navigate("tributes/add")}>Write a Tribute</button>
            </div>
            <div className="rightHero">
                <img src={require("../assets/images/Image area.png")} alt="" />
            </div>
        </div>

        <div className="homeGallery">
            <h2>Gallery</h2>

            <div className="homegrid">
                <ResponsiveMasonry
                        columnsCountBreakPoints={{500: 2, 750:3,  900: 4, 1300: 5}}
                >
                    <Masonry gutter="10px">
                        <video src={video1} controls ></video>
                        <video src={video2} controls></video>
                    <img src={img2} style={{width: "100%", display: "block", cursor: "pointer"}} onClick={() => setImage(img2)} loading="lazy" alt="photos" />
                    <img src={img5} style={{width: "100%", display: "block", cursor: "pointer"}} onClick={() => setImage(img5)} loading="lazy" alt="photos" />
                    <img src={img6} style={{width: "100%", display: "block", cursor: "pointer"}} onClick={() => setImage(img6)} loading="lazy" alt="photos" />
                    <img src={img7} style={{width: "100%", display: "block", cursor: "pointer"}} onClick={() => setImage(img7)} loading="lazy" alt="photos" />
                    <img src={img9} style={{width: "100%", display: "block", cursor: "pointer"}} onClick={() => setImage(img9)} loading="lazy" alt="photos" />
                    <img src={img10} style={{width: "100%", display: "block", cursor: "pointer"}} onClick={() => setImage(img10)} loading="lazy" alt="photos" />
                    <img src={img11} style={{width: "100%", display: "block", cursor: "pointer"}} onClick={() => setImage(img11)} loading="lazy" alt="photos" />
                    <img src={img13} style={{width: "100%", display: "block", cursor: "pointer"}} onClick={() => setImage(img13)} loading="lazy" alt="photos" />
                    
                    </Masonry>
                </ResponsiveMasonry>
            </div>
            <div className="homeGalleryButton">
            <button>View More <FaArrowRight/></button>
            </div>

            <Modal opened={image} size="auto" onClose={() => setViewImage(false)} title="Image Preview" centered>
                <div className="enlargeImageHolder">
                <img src={imageUrl} alt="" />
                <a href={imageUrl} download="image.jpg" className="downloadButton">
                    Download
                </a>
                </div>
            </Modal>
        </div>

        <div className="tributeWrapper">
            <h2>Tributes</h2>

            <div className="tributeCardWrapper">

                <div className="tributeCard" onClick={() => navigate("tributes/Chief Engr. (Dr.) Donald Ike Igwegbu (Odera)")}>
                    <div className="tributeCardHeading">
                        <img src="" alt="" />
                        <div className="tributeCardPerson">
                            <h3>Chief Engr. (Dr.) Donald Ike Igwegbu (Odera)</h3>
                            <span>CEng., CMarEng., COREN., CMC., FIMC., FIMarEST - Son</span>
                        </div>
                    </div>
                    <div className="tributeInfo">
                        <p>{"<<"}We honor the life and legacy of an extraordinary wife, mother, grandmother, great grandmother, mother-in-law, cousin, niece and friend who was 83 years young, and one whose journey has been....  {">>"}</p>
                    </div>
                </div>

            </div>

            <div className="tributeButtons">
                <button onClick={() => navigate("tributes/add")}>Write a Tribute</button>
                <NavLink to={"tributes"}>See More</NavLink>
            </div>
        </div>
    </>

}

export default Home